export default __webpack_public_path__ + "static/media/pup.217704d2.png";